// Amadeus-specific checkout request builders. Internal to the
// providers/amadeus/ folder; UI code outside it should hand a canonical
// CheckoutRequest (providers/types.js) to dispatcher.book() and stay
// provider-agnostic. The legacy `get_flight_order_body` is preserved
// here for the pre-multi-provider checkout flow (detail.vue and
// seat-selection.vue still call it to pre-populate booking_data so
// checkout.vue can render traveler/contact info before book() runs).

import { build_contact, build_traveler } from "./request";

export function get_flight_order_body(payload) {
  const { contact_details, traveler_details = [], flight_offers_pricing } = payload || {};
  return {
    data: {
      type: 'flight-order',
      flightOffers: flight_offers_pricing,
      travelers: traveler_details.map((traveler) => build_traveler(traveler, contact_details)),
      contacts: [build_contact(contact_details)],
    },
  };
}
